import Breadcrumb, { type Crumb } from '@/components/base/Breadcrumb';

interface PageHeaderProps {
  crumbs: Crumb[];
  eyebrow: string;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  imageTitle: string;
}

export default function PageHeader({
  crumbs,
  eyebrow,
  title,
  description,
  image,
  imageAlt,
  imageTitle,
}: PageHeaderProps) {
  return (
    <section className="relative w-full overflow-hidden border-b border-background-200 bg-background-100">
      <div className="pointer-events-none absolute inset-0">
        <img
          src={image}
          alt={imageAlt}
          title={imageTitle}
          className="h-full w-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/90 to-background-50/50"></div>
      </div>

      <div className="relative mx-auto max-w-content px-4 py-10 md:px-8 md:py-16">
        <Breadcrumb items={crumbs} />
        <p className="mt-6 flex items-center gap-2 text-xs font-medium tracking-[0.3em] text-primary-700">
          <span className="inline-block h-px w-6 bg-primary-500"></span>
          {eyebrow}
        </p>
        <h1 className="mt-4 max-w-3xl font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
          {title}
        </h1>
        <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
          {description}
        </p>
      </div>
    </section>
  );
}